import { render, staticRenderFns } from "./kwanzaGpo.vue?vue&type=template&id=462674b6"
import script from "./kwanzaGpo.vue?vue&type=script&lang=js"
export * from "./kwanzaGpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/vercel/path0/components/ui/field.vue').default})
